import reducer from './reducer'

export { default as actions } from './actions'

export default reducer
